import { IAppealContactInfo } from '@carm/_core/appeals/models/appeals.model';

export enum AppealStepEnum {
    AppealDetails = 'appeals.steps.appeal_details',
    RequestForExtension = 'appeals.steps.request_for_extension',
    ContactInformation = 'appeals.steps.contact_information',
    Attachments = 'appeals.steps.attachments'
}

export interface IAppealDetails {
    reason: string;
    classificationNumber?: string;
    penaltyReductionAgreement?: boolean;
}

export interface IRequestForExtension {
    withinTimeJustification: string;
    applicationJustification: string;
    circumstancesJustification: string;
    requestForExtension: boolean;
}

export interface IAppealsDraftForm {
    appealType?: string;
    requestForExtension?: boolean;
    caseNumber?: string;
    appealDetails: IAppealDetails;
    rfe?: IRequestForExtension;
    contactInfo: IAppealContactInfo;
}
